module.exports = __webpack_public_path__ + "img/ideas-workbench.2c3b3189.svg";